module.exports = __webpack_public_path__ + "img/padauk-mask.11c0457b.png";